export const langsAllowed = ['ar-SA', 'de-DE', 'da-DK', 'en-US', 'es-ES', 'el-GR', 'fr-FR', 'fi-FI', 'hi-IN', 'it-IT', 'nn-NO', 'nl-NL', 'pt-PT', 'ru-RU', 'sv-SE', 'tr-TR', 'ja-JP'];

